/** API route map: URLS.Controller.ClientSetting */
export const ClientSetting = {
      Name: 'ClientSetting/',
      GetVisibilitySetting: 'get-company-client-visibility-setting',
      AddClientVisibility: 'add-Client-Visibility',
      UpdateClientVisibility: 'update-Client-Visibility',
      GetW2Clients: 'get-w2-generation-clients',
};
